import { getItem } from './../utils/localStorage';
import axios from 'axios';
import axiosInstance from './../helpers/interceptor';
import { NotificationPreferencesPayload } from '../app/common/sharedComponents/NotificationPreferences';

export const updateToken = async (payLoad, accessToken) => {
  const { data } = await axios.put(
    `${Env.API_URL}/auth/updateTokenPassword`,
    payLoad,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return data;
};

export const acceptLQATerms = async (accessToken) => {
  const { data } = await axios.put(
    `${Env.API_URL}/auth/term`,
    {
      isTermAccepted: true,
    },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return data;
};

export const addUserActivate = async (token) => {
  const user = getItem('user');

  if (!user) {
    return;
  }

  const accessToken = user.accessToken;
  if (!accessToken) {
    return;
  }
  const { data } = await axios.put(
    `${Env.API_URL}/user-profile/addUserToProfile/${token}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return data;
};

export const getDepartmentForUser = async (id, accessToken) => {
  const { data } = await axiosInstance.get(
    `${Env.API_URL}/auth/user/department/${id}`
  );
  return data;
};

export const getNotificationPreferences = async () => {
  return await axiosInstance.get(
    `${Env.API_URL}/auth/me`);
    // `${Env.API_URL}/auth/updateNotificationSettings`);
};

export const putNotificationPreferences = async (payload: NotificationPreferencesPayload) => {
  return await axiosInstance.put(
    `${Env.API_URL}/auth/updateNotificationSettings`, payload);
};
